// extracted by mini-css-extract-plugin
export default {"block":"BlogPreview_block__-iJ9Q","blogTitle":"BlogPreview_blogTitle__A+6pN","blogPreview":"BlogPreview_blogPreview__J482O"};